import { logError } from './logError';

export const copyToClipboard = (
  text: string,
  callback?: () => unknown,
): void => {
  if (window.navigator.clipboard) {
    window.navigator.clipboard
      .writeText(text)
      .then(callback)
      .catch(error => {
        logError('Unable to save navigator clipboard', error);
      });
  } else {
    // Fallback for older browsers
    const textarea = document.createElement('textarea');
    textarea.value = text;

    // Avoid scrolling to bottom
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.position = 'fixed';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand?.('copy')
        ? callback?.()
        : logError('Unable to save to clipboard.');
    } catch (err) {
      logError('Unable to save to clipboard. Error thrown');
    }
    document.body.removeChild(textarea);
  }
};
